import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { useUserAmbitionOptionsQuery, useUserAmbitionsQuery } from '~/shared/query-hooks/use-ambition';

import { EditButton } from '../../../../common/buttons/EditButton';
import { editUserAmbitionsUrl } from '../../constants';
import { AddButton } from '../../user-profile/common/ActionButtons';
import { AmbitionContent } from './AmbitionContent';

type AmbitionsProps = {
    readonly userId: string;
};

export const Ambitions: FunctionComponent<AmbitionsProps> = ({ userId }) => {
    const { actions } = useContext(ApplicationContext);
    const { data: ambitionOptions } = useUserAmbitionOptionsQuery(userId);
    const canReadAmbitions = ambitionOptions?.canReadAmbitions ?? false;
    const canEditAmbitions = ambitionOptions?.canReadAmbitions ?? false;
    const { data: ambitions } = useUserAmbitionsQuery(userId, canReadAmbitions);

    const actionButtonOnClick = (): void => actions.navigateTo(editUserAmbitionsUrl(userId));
    const actionButton = is.emptyArray(ambitions) ? (
        <AddButton aria-label="Add Ambitions" onClick={actionButtonOnClick} />
    ) : (
        <EditButton aria-label="Edit Ambitions" onClick={actionButtonOnClick} />
    );

    return <AmbitionContent action={canEditAmbitions ? actionButton : null} ambitions={ambitions} />;
};
